// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__zgfvB","name":"ConsentHeader_name__2D02L","birthday":"ConsentHeader_birthday__3ivJU","skeleton":"ConsentHeader_skeleton__1AY3Z"};